module.exports = {
  css: `
  *, *:before, *:after {
    box-sizing: border-box;
  }

  body {
    margin: 0px;
    background-color: #FFF;
  }

  h1 {
    font-size: 4em;
  }

  h2 {
    font-size: 2em;
  }

  h1 {
    color: var(--primary-text-colour) !important;
  }

  h2 {
    color: #000000;
  }

  h1, h2, h3, h4 {
    font-family: var(--title-font) !important;
    font-weight: var(--title-weight) !important;
  }

  h1 {
    text-align: center;
  }

  h2 {
    font-size: 2.5em;
    margin-bottom: 0.3em;
  }

  h3 {
    font-size: 1.5em;
    color: #000000;
  }

  h4 {
    font-size: 1.2em;
    color: #000000;
  }

  a, p, li {
    font-family: var(--body-font)  !important;
  }

  p {
    color: #222222;
  }

  .pure-button-primary {
    color: var(--secondary-text-colour) !important;
    background-color: var(--secondary-background-colour) !important;
  }

  .pure-button-primary:hover {
    color: var(--secondary-text-colour) !important;
    background-color: var(--secondary-background-colour) !important;
  }

  .pure-button {
    font-family: var(--body-font)  !important;
    padding: 0.8em;
    text-transform: uppercase;
    border-radius: 4px;
    background-color: transparent;
    background: none;
    transition: all .2s ease-in-out;
  }

  .pure-button:hover {
    background: none;
    transform: scale(1.05);
  }

  .kk-checklist {
    list-style: none;
    padding: 0px;
    line-height: 1.5em;
  }

  .kk-checklist li:before {
    content: '✓ ';
  }

  .kk-arrow {
    color: inherit;
    margin-left: 0.8em;
    padding-left: 2px;
    padding-right: 2px;
  }

  .pure-button:after {
    content: '\\00a0 \\00a0 \\00a0 ❯';
  }

  .kk-nav {
    text-align: left;
    padding-top: 1em;
    padding-bottom: 1em;
    padding-left: 4em;
    padding-right: 4em;
    position: fixed;
    top: 0;
    width: inherit;
    box-sizing: border-box;
    z-index: 3;
  }

  .kk-nav-links {
    text-align: right;
  }

  .pure-menu-link {
    color: #FFFFFF;
  }

  .pure-sub-menu-link {
    color: #000 !important;
  }

  .kk-nav-scrolled {
    color: #FFFFFF !important;
    background-color: var(--primary-background-colour) !important;
  }

  .kk-block-blog-container {
    overflow: visible !important;
  }

  .pure-menu-children {
    margin-left: -51px;
  }

  .pure-menu {
    text-align: right;
  }

  .kk-block-blog {
    background: white;
    position: relative;
    padding: 2em;
    top: -100px;
    z-index: 2;
    border-radius: 8px;
    border: 1px solid #DDD;
  }

  .kk-block-blog img {
    width: 100%;
    padding-top: 1em;
    padding-bottom: 1em;
  }

  .kk-nav-link {
    margin-left: 1em;
    color: var(--primary-text-colour);
  }

  .kk-nav-link-dropdown {
    color: var(--primary-text-colour);
  }

  .kk-logo-image {
    height: 48px;
  }

  .kk-muted {
    color: #707070;
  }

  .text-light p, .text-light h1, .text-light h2, .text-light h3, .text-light .pure-menu-link, .text-light .pure-menu-item {
    color: #FFF !important;
  }

  .text-dark p, .text-dark h1, .text-dark h2, .text-dark h3, .text-dark .pure-menu-link, .text-dark .pure-menu-item {
    color: #000 !important;
  }

  .kk-block {
    overflow:auto;
    padding-left: 2em;
    padding-right: 2em;
    width: 100%;
    box-sizing: border-box;
    padding-top: 45px;
    padding-bottom: 45px;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    overflow:visible
  }

  .kk-block-footer {
    text-align: center;
  }

  .kk-block-hero {
    background-color: var(--primary-background-colour) !important;
    text-align: center;
    padding-bottom: 4em;
    min-height: 360px;
    width: 100%;
    padding-top: 60px;
  }

  .kk-block-hero-image {
    display: block;
    max-height: 320px;
    margin: auto;
  }

  .kk-block-image {
    max-height: 320px;
  }

  .kk-block-left {
    width: 50%;
    display: inline;
  }

  .kk-block-right {
    width: 50%;
    display: inline;
    text-align: center;
  }

  .kk-block-container {
    max-width: 900px;
    margin: auto;
    text-align: center;
  }

  .kk-subheading {
    max-width: 600px;
    margin: auto;
    margin-bottom: 1em;
    line-height: 1.6em;
  }

  .kk-block-left {
    text-align: center;
  }

  .kk-container {
    display: flex;
    flex-flow: row wrap;

    align-items: center;
    justify-content: center;
  }

  .kk-link {
    text-decoration: none;
  }

  .kk-link:hover {
    text-decoration: none;
  }

  .kk-logo {
    padding: 1em;
    height: 72px;
    filter: grayscale(100%);
  }

  .kk-logo:hover {
    filter: grayscale(0%);
  }

  .kk-card {
    padding: 2em;
    height: 100%;
    border-radius: 4px;
    background-color: #FFFFFF;
    border: 1px solid #999;
  }

  .kk-line {
    width: 120px;
    height: 3px;
    background-color: #000;
    margin: auto;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .kk-mt-0 {
    margin-top: 0em !important;
  }

  .kk-mt-2 {
    margin-top: 2em !important;
  }

  .kk-mt-4 {
    margin-top: 4em !important;
  }

  .kk-mb-0 {
    margin-bottom: 0em !important;
  }

  .kk-mb-1 {
    margin-bottom: 1em !important;
  }

  .kk-mb-2 {
    margin-bottom: 2em !important;
  }

  .kk-mb-4 {
    margin-bottom: 4em !important;
  }

  .kk-m-a {
    margin: auto;
  }

  .kk-space-between {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .kk-float-right {
    float: right;
    justify-content: flex-end;
  }

  .pure-g {
    letter-spacing: inherit;
  }

  .pure-g.gutters{
    margin: 0 -1em;
    align-items: stretch;
  }
  .pure-g.gutters > [class *=pure-u]{
    box-sizing: border-box;
    padding: 0em 1em;
  }

  .pure-v-center {
    display: flex;
    align-items: center;
  }

  .kk-text-center {
    text-align: center;
  }

  .pure-text-primary {
    color: var(--primary-background-colour) !important;
  }

  .kk-cta-link {
    font-family: var(--title-font) !important;
    font-weight: var(--title-weight) !important;
    color: var(--secondary-text-colour) !important;

    background-color: var(--secondary-background-colour);
    padding: 1em 1.5em;
    text-decoration: none;
    text-transform: uppercase;

    display: inline-block;
  }

  .kk-cta-link:hover {
    text-decoration: none;
    position: relative;
    top: -2px;
  }

  .kk-card-icon {
    height: 64px;
    width: 64px;
    /* border: 1px solid #707070; */
    padding-right: 0.5em;
    object-fit: contain;
  }

  .kk-hero-subheading {
    color: var(--primary-text-colour) !important;
  }

  .kk-text-logo {
    color: var(--primary-text-colour) !important;
  }

  .accordion {
    padding: 1em;
    cursor: pointer;
    width: 100%;
    border: 1px solid #707070;
    text-align: left;
    outline: none;
    transition: 0.4s;
    background-color: transparent;
    border-radius: 4px;
  }

  .accordion:after {
    content: '+'; /* Unicode character for "plus" sign (+) */
    float: right;
  }

  .active:after {
    content: "-"; /* Unicode character for "minus" sign (-) */
  }

  .active, .accordion:hover {
    background-color: var(--primary-background-colour);
    color: #FFFFFF;
  }

  .panel {
    padding: 2em;
    display: none;
    overflow: hidden;
    text-align: left;
  }

  .kk-form-input {
    box-shadow: none  !important;
    border: 1px solid #707070  !important;
    padding: 0.8em !important;
    display: block !important;
    margin-bottom: 1em;
    width: 400px;
  }

  .kk-float-left {
    justify-content: end;
    text-align: left !important;
  }

  .kk-float-right {
    text-align: right !important;
  }
  `
}
